import axios from "axios";
import { FETCH_ALL_COLOR_API } from "../Constants/Apis";

export const getColors = async () => {
  try {
    return axios.get(FETCH_ALL_COLOR_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createColor = async (payload) => {
  try {
    return axios.post(FETCH_ALL_COLOR_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateColor = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_COLOR_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteColor = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_COLOR_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

export const getMaxColorCode = async () => {
  try {
    return axios.get(`${FETCH_ALL_COLOR_API}/max-code`);
  } catch (e) {
    return console.log(e);
  }
};

export const getFirstAvailableColorCode = async () => {
  try {
    const response = await getColors();
    
    // Try different possible response structures
    let colors = null;
    
    if (response && response.data) {
      // Check if data is directly in response.data
      if (Array.isArray(response.data)) {
        colors = response.data;
      }
      // Check if data is in response.data.data
      else if (response.data.data && Array.isArray(response.data.data)) {
        colors = response.data.data;
      }
      // Check if data is in response.data.colors
      else if (response.data.colors && Array.isArray(response.data.colors)) {
        colors = response.data.colors;
      }
    }
    
    if (colors && colors.length > 0) {
      // Debug: Log the raw color data
      
      // Extract all existing codes and normalize them to numbers
      // Handle both "1" and "001" formats by parsing as integers
      const existingCodes = colors
        .map(color => {
          // Remove leading zeros and parse as integer
          const codeStr = color.code.toString().replace(/^0+/, '') || '0';
          const parsedCode = parseInt(codeStr, 10);
          console.log(`Code: "${color.code}" -> "${codeStr}" -> ${parsedCode}`);
          return parsedCode;
        })
        .filter(code => !isNaN(code) && code >= 1 && code <= 999)
        .sort((a, b) => a - b);
      
      
      // Find the first missing code
      for (let i = 1; i <= 999; i++) {
        if (!existingCodes.includes(i)) {
          console.log(`First available code found: ${i} -> ${i.toString().padStart(3, "0")}`);
          return i.toString().padStart(3, "0");
        }
      }
      
      // If all codes 1-999 are taken, return null
      return null;
    }
    
    return "001"; // Default fallback
  } catch (e) {
    return "001"; // Default fallback
  }
};

